// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__YxPCs","sendOtp":"AuthorizeToLogin_sendOtp__1Mn5c"};